export function IconVerDash() {
  return (
    <svg
      width="8"
      height="9"
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="4" width="2" height="5" fill="white" />
      <rect x="3" width="2" height="9" fill="white" />
      <rect x="6" y="2" width="2" height="7" fill="white" />
    </svg>
  );
}
export function IconVerDesk() {
  return (
    <svg
      width="13"
      height="7"
      viewBox="0 0 13 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.4062 3.69726C1.40136 3.7025 1.40136 3.71057 1.4066 3.71542C3.11254 5.3701 4.88951 6.18493 6.68343 6.13771C9.23487 6.07031 11.0869 4.28164 11.5938 3.73479M1.4062 3.69726L1.41545 3.70583L1.41569 3.70605L1.44287 3.73125C1.45077 3.72273 1.45899 3.7139 1.46754 3.70479M1.4062 3.69726L1.41547 3.70581L1.41571 3.70603L1.44294 3.73117C1.45501 3.71809 1.45717 3.69498 1.44141 3.67953C1.44112 3.67924 1.44082 3.67896 1.44052 3.67868L1.44143 3.67952L1.44142 3.67953C1.45012 3.68797 1.45883 3.69639 1.46754 3.70479M1.4062 3.69726L11.5934 3.71663C11.5986 3.72147 11.5986 3.72954 11.5938 3.73479M1.46754 3.70479C3.15901 5.33622 4.91466 6.13425 6.68211 6.08773C9.1726 6.02194 10.9943 4.30082 11.5325 3.72725M1.46754 3.70479C2.00533 3.13158 3.82742 1.4101 6.31789 1.34432L6.31657 1.29433L6.31779 1.34432C6.36718 1.34311 6.41598 1.34232 6.46509 1.34232C8.18389 1.34232 9.88763 2.14098 11.5325 3.72725M11.5325 3.72725C11.5412 3.73565 11.5499 3.74408 11.5586 3.75252M11.5325 3.72725C11.541 3.71814 11.5492 3.70932 11.5571 3.7008L11.5843 3.72599L11.5845 3.72621L11.5938 3.73479M11.5586 3.75252L11.5586 3.75253L11.5595 3.75337C11.5592 3.75309 11.5589 3.75281 11.5586 3.75252ZM11.5586 3.75252C11.5428 3.73707 11.545 3.71395 11.5571 3.70088L11.5843 3.72601L11.5845 3.72623L11.5938 3.73479M11.8896 4.00922C11.3557 4.58514 9.40276 6.46946 6.69392 6.54129C6.64065 6.5425 6.58738 6.54331 6.5341 6.54331C4.68126 6.54331 2.86232 5.69014 1.12571 4.00519C0.964279 3.8486 0.957418 3.58748 1.11038 3.42282C1.64391 2.84691 3.59684 0.96259 6.30568 0.890753L11.8896 4.00922ZM6.30435 0.84077C3.57425 0.913172 1.60918 2.81083 1.07372 3.38882C0.902261 3.57342 0.909973 3.86558 1.09089 4.04107C2.83389 5.73222 4.66466 6.59331 6.5341 6.59331C6.58787 6.59331 6.64154 6.5925 6.69506 6.59128L6.69525 6.59128C9.42533 6.51887 11.3904 4.62124 11.9263 4.04325C12.0977 3.85869 12.0901 3.56611 11.9091 3.39097C10.1155 1.65119 8.23089 0.790276 6.30437 0.84077L6.30435 0.84077Z"
        fill="white"
        stroke="white"
        strokeWidth="0.1"
      />
      <path
        d="M4.53984 3.71484C4.53984 4.7958 5.41903 5.67499 6.49999 5.67499C7.58095 5.67499 8.46014 4.7958 8.46014 3.71484C8.46014 2.63388 7.58095 1.75469 6.49999 1.75469C5.41903 1.75469 4.53984 2.63388 4.53984 3.71484ZM5.04342 3.71484C5.04342 2.91188 5.69704 2.25827 6.49999 2.25827C7.30295 2.25827 7.95656 2.91188 7.95656 3.71484C7.95656 4.51779 7.30295 5.17141 6.49999 5.17141C5.69704 5.17141 5.04342 4.51779 5.04342 3.71484Z"
        fill="white"
        stroke="white"
        strokeWidth="0.1"
      />
    </svg>
  );
}
export function IconResumoDeskTimeline({ size = 16 }: any) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 37 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.8667 11.2103L31.2095 4.89348C31.4759 4.3839 31.6165 3.79656 31.5871 3.17418C31.5049 1.43716 30.0992 0.0441566 28.3855 0.00105322C26.5339 -0.0456756 25.0131 1.46858 25.0131 3.33653C25.0131 4.3134 25.4292 5.194 26.0911 5.8047L20.2541 14.6232C19.8415 14.4334 19.3841 14.3271 18.902 14.3271C18.3512 14.3271 17.8319 14.4656 17.3756 14.7098L13.6713 10.4856C14.0922 9.91603 14.3376 9.20583 14.3261 8.43803C14.3002 6.69496 12.9327 5.25039 11.2165 5.15734C9.32206 5.05502 7.74883 6.58902 7.74883 8.48919C7.74883 8.85698 7.80879 9.21107 7.91759 9.5422L0.240847 14.4556C-0.000180102 14.6099 -0.0724486 14.9333 0.0796329 15.1779C0.231714 15.4224 0.550569 15.4957 0.791597 15.3414L8.39527 10.474C8.99526 11.2933 9.9558 11.8255 11.037 11.8255C11.7411 11.8255 12.3935 11.5991 12.9291 11.2156L16.5453 15.339C15.9696 15.9396 15.6134 16.7582 15.6126 17.6601C15.611 19.4245 16.9865 20.9017 18.7233 20.9952C20.6174 21.0971 22.1902 19.5631 22.1902 17.6634C22.1902 16.6881 21.7757 15.8095 21.1157 15.1988L26.9536 6.37914C27.365 6.56766 27.8212 6.67321 28.3013 6.67321C29.1828 6.67321 29.9841 6.31871 30.5753 5.74387L36.1019 11.9149C36.2937 12.1288 36.6201 12.1449 36.8309 11.9503C37.0418 11.7558 37.0577 11.4246 36.8659 11.2107L36.8667 11.2103ZM8.78084 8.48878C8.78084 7.2267 9.79299 6.19947 11.0374 6.19947C12.2819 6.19947 13.294 7.2263 13.294 8.48878C13.294 9.75127 12.2819 10.7781 11.0374 10.7781C9.79299 10.7781 8.78084 9.75127 8.78084 8.48878ZM18.902 19.9523C17.6579 19.9523 16.6454 18.9254 16.6454 17.6629C16.6454 16.4005 17.6576 15.3736 18.902 15.3736C20.1464 15.3736 21.1586 16.4005 21.1586 17.6629C21.1586 18.9254 20.1464 19.9523 18.902 19.9523ZM28.3017 5.62543C27.0576 5.62543 26.0451 4.59861 26.0451 3.33612C26.0451 2.07364 27.0572 1.04681 28.3017 1.04681C29.5461 1.04681 30.5583 2.07364 30.5583 3.33612C30.5583 4.59861 29.5461 5.62543 28.3017 5.62543Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function IconResumoDeskTarefas({ size = 16 }: any) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.3913C4.35012 1.3913 1.3913 4.35012 1.3913 8C1.3913 11.6499 4.35012 14.6087 8 14.6087C11.6499 14.6087 14.6087 11.6499 14.6087 8C14.6087 4.35012 11.6499 1.3913 8 1.3913ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM11.9702 5.07332C12.2418 5.34499 12.2418 5.78545 11.9702 6.05712L7.30435 10.7229L4.37767 7.79625C4.106 7.52458 4.106 7.08412 4.37767 6.81245C4.64933 6.54078 5.0898 6.54078 5.36147 6.81245L7.30435 8.75533L10.9864 5.07332C11.258 4.80165 11.6985 4.80165 11.9702 5.07332Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function IconResumoDeskNotas({ size = 16 }: any) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="14.3333"
        height="21.303"
        rx="2.5"
        stroke="currentColor"
      />
      <path
        d="M3.48438 6.27344H11.848"
        stroke="currentColor"
        stroke-linecap="round"
      />
      <path
        d="M3.48438 9.41016H11.848"
        stroke="currentColor"
        stroke-linecap="round"
      />
      <path
        d="M3.48438 12.8945H11.848"
        stroke="currentColor"
        stroke-linecap="round"
      />
      <path
        d="M3.48438 16.3789H11.848"
        stroke="currentColor"
        stroke-linecap="round"
      />
    </svg>
  );
}
export function IconBullet() {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="6" stroke="black" strokeWidth="3" />
    </svg>
  );
}
export function IconCriarNovaTarefa() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 1.27594C10.9323 1.27594 13.7241 4.06856 13.7241 7.5C13.7241 10.9314 10.9314 13.7241 7.5 13.7241C4.06856 13.7241 1.27594 10.9323 1.27594 7.5C1.27594 4.06771 4.06856 1.27594 7.5 1.27594ZM7.5 0C3.35829 0 0 3.35829 0 7.5C0 11.6417 3.35829 15 7.5 15C11.6417 15 15 11.6417 15 7.5C15 3.35829 11.6426 0 7.5 0Z"
        fill="white"
      />
      <path
        d="M8.13818 8.13671L11.2972 8.13671C11.6497 8.13671 11.9354 7.85101 11.9354 7.49854C11.9354 7.14607 11.6497 6.86036 11.2972 6.86036L8.13818 6.86036L8.13818 3.70136C8.13818 3.34889 7.85247 3.06318 7.5 3.06318C7.14753 3.06318 6.86182 3.34889 6.86182 3.70136L6.86182 6.86036L3.70282 6.86036C3.35035 6.86036 3.06464 7.14607 3.06464 7.49854C3.06464 7.67417 3.13562 7.83417 3.2511 7.94965C3.36659 8.06514 3.52598 8.13671 3.70222 8.13611L6.86122 8.13611L6.86122 11.2951C6.86122 11.4708 6.9322 11.6307 7.04768 11.7462C7.16317 11.8617 7.32256 11.9333 7.4988 11.9327C7.85127 11.9327 8.13697 11.647 8.13697 11.2945L8.13697 8.13551L8.13818 8.13671Z"
        fill="white"
      />
    </svg>
  );
}
export function IconIsOpen() {
  return (
    <svg
      width="17"
      height="9"
      viewBox="0 0 17 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.47482 0.000177592C8.75831 0.000177616 9.04179 0.0984252 9.25883 0.292916L16.6781 7.00984C17.1099 7.40283 17.1099 8.03643 16.6781 8.42942C16.244 8.8204 15.5441 8.8204 15.11 8.42942L8.47482 2.42228L1.89053 8.38129C1.45867 8.77228 0.756611 8.77228 0.324745 8.38129C-0.10712 7.99031 -0.10712 7.35471 0.324745 6.96372L7.69082 0.294921C7.90786 0.0984251 8.19134 0.00218219 8.47482 0.00218222L8.47482 0.000177592Z"
        fill="#153DCE"
      />
    </svg>
  );
}
export function IconIsClose() {
  return (
    <svg
      width="17"
      height="9"
      viewBox="0 0 17 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.52713 8.72248C8.24365 8.72248 7.96017 8.62423 7.74313 8.42974L0.323899 1.71282C-0.107966 1.31983 -0.107966 0.686229 0.323899 0.293239C0.757979 -0.0977463 1.45782 -0.0977463 1.8919 0.293239L8.52713 6.30037L15.1114 0.34136C15.5433 -0.049625 16.2453 -0.049625 16.6772 0.34136C17.1091 0.732345 17.1091 1.36795 16.6772 1.75893L9.31113 8.42773C9.09409 8.62423 8.81061 8.72047 8.52713 8.72047V8.72248Z"
        fill="#153DCE"
      />
    </svg>
  );
}
export function IconEdit() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
    </svg>
  );
}
export function IconDelete() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
    </svg>
  );
}
export function IconResumoDeskChecklist({ size = 16 }: any) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 1.5A1.5 1.5 0 0 1 3.5 0h9A1.5 1.5 0 0 1 14 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5V1.5zm1.5-.5a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-9z"
      />
      <path d="M4.646 5.646a.5.5 0 0 1 .708 0L6.5 6.793l2.646-2.647a.5.5 0 0 1 .708.708L6.5 8.207 4.646 6.354a.5.5 0 0 1 0-.708zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z" />
    </svg>
  );
}
